import { render } from "./ClientNote.vue?vue&type=template&id=ea404d0e&scoped=true"
import script from "./ClientNote.vue?vue&type=script&lang=ts"
export * from "./ClientNote.vue?vue&type=script&lang=ts"

import "./ClientNote.vue?vue&type=style&index=0&id=ea404d0e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ea404d0e"

export default script